import React from "react";
import { Radio, Space } from "antd-mobile";
import { Field, isVoidField } from "@formily/core";
import { useField, observer } from "@formily/react";
interface Item {
  value: string;
  label: string;
}

interface IProps {
  value?: any;
  onChange?: (items: Item[]) => void;
  placeholder?: string;
}

const Cmp = (props) => {
  return <div>{props.value}</div>;
};

export const CustomRadio: React.FC<IProps> = observer((props) => {
  const { onChange, value } = props;
  const field: any = useField<Field>();

  let dataSource = field?.dataSource?.length ? field?.dataSource : [];
  if (field?.CustomDisabled) {
    dataSource = dataSource.map((item) => {
      if (field?.CustomDisabled?.includes(item.value)) {
        return { ...item, disabled: true };
      }
      return item;
    });
  }
  // 点击单选框的处理函数
  const handleRadioChange = (item) => {
    onChange(item);
  };

  if (!isVoidField(field) && field?.pattern === "readPretty") {
    return <Cmp />;
  }

  return (
    <div>
      {dataSource && (
        <Radio.Group onChange={handleRadioChange} value={value}>
          <Space key="verticalSpace" direction="horizontal" style={{ flexWrap: "wrap" }}>
            {dataSource.map((item: any) => (
              <Radio
                key={item.value}
                value={item.value}
                disabled={item.disabled}
              >
                {item.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      )}
    </div>
  );
});
export default CustomRadio;
